import { defineStore } from "pinia";
import { History, ImageData, Triangle, CanvasData, Point } from "@/types";

interface MainState {
    correction: number;
    imageData: ImageData;
    triangles: Triangle[];
    points: Point[];
    history: History;
    currentEdit: number;
    canvas: {
        original: CanvasData;
        render: CanvasData;
        triangle: CanvasData;
    };
}

export const useMainStore = defineStore("main", {
    state: () => {
        return {
            correction: 100,
            imageData: [],
            triangles: [],
            points: [],
            history: [],
            currentEdit: 0,
            canvas: {
                original: {
                    context: null,
                    size: { width: 0, height: 0 },
                },
                render: {
                    context: null,
                    size: { width: 0, height: 0 },
                },
                triangle: {
                    context: null,
                    size: { width: 0, height: 0 },
                },
            },
        } as MainState;
    },
    getters: {},
    actions: {},
});
